/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sets: NonNullable<unknown>, target: NonNullable<unknown> }} Progress_Extra_Map_Sets_OfInputs */

const en_us2_progress_extra_map_sets_of = /** @type {(inputs: Progress_Extra_Map_Sets_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} of ${i?.target} sets`)
};

const pt_br2_progress_extra_map_sets_of = /** @type {(inputs: Progress_Extra_Map_Sets_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} de ${i?.target} séries`)
};

const es_419_progress_extra_map_sets_of = /** @type {(inputs: Progress_Extra_Map_Sets_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} de ${i?.target} series`)
};

const pt_pt2_progress_extra_map_sets_of = /** @type {(inputs: Progress_Extra_Map_Sets_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} de ${i?.target} séries`)
};

const fr_fr2_progress_extra_map_sets_of = /** @type {(inputs: Progress_Extra_Map_Sets_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} séries sur ${i?.target}`)
};

const de_de2_progress_extra_map_sets_of = /** @type {(inputs: Progress_Extra_Map_Sets_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} von ${i?.target} Sätzen`)
};

const it_it2_progress_extra_map_sets_of = /** @type {(inputs: Progress_Extra_Map_Sets_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} di ${i?.target} serie`)
};

/**
* | output |
* | --- |
* | "{sets} of {target} sets" |
*
* @param {Progress_Extra_Map_Sets_OfInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_map_sets_of = /** @type {((inputs: Progress_Extra_Map_Sets_OfInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Map_Sets_OfInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_map_sets_of(inputs)
	if (locale === "es-419") return es_419_progress_extra_map_sets_of(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_map_sets_of(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_map_sets_of(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_map_sets_of(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_map_sets_of(inputs)
	return en_us2_progress_extra_map_sets_of(inputs)
});
export { progress_extra_map_sets_of as "progress-extra.map_sets_of" }